import { gsap } from 'gsap'
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default {
  init() {
    console.log('single ricetta');

	new Swiper('.swiperGuide', {
		modules: [Pagination],
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		slidesPerView: 1,
		spaceBetween: 10,
		direction: 'horizontal',
		loop: false,	
	});

    new Swiper('.swiperSingleRicettaRelated', {
		modules: [Navigation],
		slideToClickedSlide: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 3,
		breakpoints: {
			1024: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 2,
			},
			320: {
				slidesPerView: 1,
			},
		},
		spaceBetween: 50,
		direction: 'horizontal',
		loop: false,
	});


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
